import React from 'react';

import { BirthPlan, BirthPlanService } from '../../general/ServerClient';
import { useAppContext } from '../page/WebappContext';
import {
  UpdateProfileButtonList,
  UpdateProfileInformationDialog
} from './UpdateProfileInformationDialog';

export const UpdateProviderDialog: React.FC<{
  isOpen: boolean;
  dismiss: () => void;
}> = ({ isOpen, dismiss }) => {
  const { birthPlan, options } = useAppContext();

  return (
    <UpdateProfileInformationDialog
      open={isOpen}
      onClose={dismiss}
      title="Who's leading your care?"
    >
      {options.data ? (
        <UpdateProfileButtonList
          options={options.data.providers}
          initialSelectedId={birthPlan.data?.birth_provider}
          onCancel={dismiss}
          onSubmit={(selectedId) => {
            if (birthPlan.data) {
              const newBirthPlan: BirthPlan = {
                ...birthPlan.data,
                birth_provider: selectedId
              };
              birthPlan.setData(newBirthPlan);
              BirthPlanService.birthPlanProfileCreate(newBirthPlan);
            }
            dismiss();
          }}
        ></UpdateProfileButtonList>
      ) : (
        <div>Error: no birth plan options</div>
      )}
    </UpdateProfileInformationDialog>
  );
};
